const state = {
  showSpecificLocationStep: false,
  selectedLocationStep: '',
};

const getters = {
  showSpecificLocationStep: ({showSpecificLocationStep}) => showSpecificLocationStep,
  selectedLocationStep: ({selectedLocationStep}) => selectedLocationStep,
};

const actions = {
  setShowSpecificLocationStep: ({commit}, showSpecificLocation) => commit('setShowSpecificLocationStep', showSpecificLocation),
  setSelectedLocationStep: ({commit}, selectedLocationStep) => commit('setSelectedLocationStep', selectedLocationStep),
};

const mutations = {
  setShowSpecificLocationStep(state, showSpecificLocation) {
    state.showSpecificLocationStep = showSpecificLocation;
  },
  setSelectedLocationStep(state, selectedLocationStep) {
    state.selectedLocationStep = selectedLocationStep;
  },
};

const aiOnboarding = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default aiOnboarding;
